import { render, staticRenderFns } from "./SetMall.vue?vue&type=template&id=54ead6a2&scoped=true"
import script from "./SetMall.vue?vue&type=script&lang=js"
export * from "./SetMall.vue?vue&type=script&lang=js"
import style0 from "./SetMall.vue?vue&type=style&index=0&id=54ead6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ead6a2",
  null
  
)

export default component.exports